'use strict';

angular.module('amexReconciliationApp')
  .component('transactionIconsHeader', {
    templateUrl: 'scripts/views/components/transaction-icons-header.html',
    controller: function (TransactionSortModel) {
      var self = this;

      self.sortByLockStatus = function () {
        TransactionSortModel.setSortField('lockStatus');
      };

      self.sortByStatus = function () {
        TransactionSortModel.setSortField('mutableTransactionProperties.transactionStatus');
      };

      self.sortByExceptionNote = function () {
        TransactionSortModel.setSortField('details.exceptionFlag');
      };

      self.sortByLineItemDetails = function () {
        TransactionSortModel.setSortField('lineItemDetails.hasLineItems');
      };

      self.sortByComments = function () {
        TransactionSortModel.setSortField('mutableTransactionProperties.commentIndicator');
      };
    }
  });


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/transactionIconsHeader.js
// module id = 488
// module chunks = 0